import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { UserApi } from '../../../../../../redux/api/UserApi';
import * as FilterSlice from '../../../../../../slices/FilterSlice';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { Setting } from '../../../../../../types/Setting/Setting';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { useCurrentUserContext } from '../../../../../../context/UserContext';


const ActionFilterButton: React.FC<ITicketProps> = ({ Is_Loading }) => {
    const { profile: userProfile } = useCurrentUserContext();
    const { data: myFilterSettings } = UserApi.useGetSettingQuery(Setting.Ticket_Action_Filter, { skip: !userProfile?.Features.Call_Action_Filter });
    const updateState = useReduxDispatch();
    const filterState = useReduxSelector(state => state.filter);

    //Load the user's personal settings into state
    useEffect(() => {
        if (myFilterSettings) {

            var filterValues = myFilterSettings?.String_Value?.split(';');
            if (!filterValues) return;

            //Authors
            filterValues.length > 0 && filterValues[0].length > 0 && updateState(FilterSlice.setAuthors(filterValues[0].split(',').map(a => parseInt(a))));
            //Authors And Or
            filterValues.length > 1 && updateState(FilterSlice.setAuthorAndOr(filterValues[1]?.toLocaleLowerCase() === 'or' ? 'or' : 'and'));
            //Action Types
            filterValues.length > 2 && filterValues[2].length > 0 && updateState(FilterSlice.setActionTypes(filterValues[2].split(',').map(a => parseInt(a))));
            //Action Types And Or
            filterValues.length > 3 && updateState(FilterSlice.setActionTypeAndOr(filterValues[3]?.toLocaleLowerCase() === 'or' ? 'or' : 'and'));
            //Include / Exclude search term
            filterValues.length > 4 && updateState(FilterSlice.setSearchTermOption(filterValues[4] === '1' ? 'Include' : 'Exclude'));
            //Search Term
            filterValues.length > 5 && updateState(FilterSlice.setSearchTerm(filterValues[5]));
            //System actions
            filterValues.length > 6 && updateState(FilterSlice.setShowSystemActions(filterValues[6].toLocaleLowerCase() === 'true'));
            //Date range
            filterValues.length > 7 && filterValues[7].length > 0 && filterValues[7] != 'None' && updateState(FilterSlice.setDateRange(filterValues[7] as dateRangeOptions));
            //From date
            filterValues.length > 8 && filterValues[8].length > 0 && updateState(FilterSlice.setStartDate(new Date(filterValues[8])));
            //To date
            filterValues.length > 9 && filterValues[9].length > 0 && updateState(FilterSlice.setEndDate(new Date(filterValues[9])));
            //HAs reactions
            filterValues.length > 10 && updateState(FilterSlice.setHasReaction(filterValues[10].toLocaleLowerCase() === 'true'));
        }
    }, [myFilterSettings]);

    //Checks if the user has a filter applied by looping through the object keys / properties and comparing them to the default state
    const hasFilterApplied = Object.keys(filterState).some(key => {
        var areDifferent = filterState[key] !== FilterSlice.initialState[key]
        //if (areDifferent)
        //  console.log('key', key, filterState[key], FilterSlice.initialState[key], filterState[key] === FilterSlice.initialState[key]);


        return areDifferent;
    });

    if (!userProfile?.Features.Call_Action_Filter) return null;

    return (
        <Link to={Is_Loading ? '' : 'filter'}>
            <Button disabled={Is_Loading} className={hasFilterApplied && 'on'} imageUrl={hasFilterApplied ? './images/cancel-filters.png' : './images/toolbar/filter.png'} size='medium'></Button>
        </Link>
    );
};

export default ActionFilterButton;